/** @jsxImportSource @emotion/react */
import { useState, useEffect, useContext } from 'react';
import config from '../../config';
import PageLayout from '../Layout/PageLayout';
import { Il8nContext } from '../../Helper/i18n';
import { useNavigate } from 'react-router-dom';
import axios from '../../Helper/Axios/interceptor';
import { useDispatch, useSelector } from 'react-redux';
import ElevatedGrid from '../../Components/ElevatedGrid';
import Popup, { PopupTitle } from '../../Components/CustomPopup';
import { addStageData, updateStepper } from '../../Helper/Redux/reducers/upDown';
import MySnackbarContentWrapper from '../../Components/Snackbars';
import { Button, Snackbar, DialogActions, DialogContent, FormControl, FormControlLabel, Grid, Radio, RadioGroup, Typography, useMediaQuery, useTheme, Paper, List, ListItem } from '@mui/material';
import { appStages, Steps } from '../../Helper/AppStepperData';
import { setCookieNew } from '../../Helper/Cookies/cookies';

const classes = {
    root: {
      margin: 0,
      height: '130px',
      display: 'flex'
    },
    topContainer:{
        padding:'45px 35px 45px 35px',
        display:'flex',
        flexDirection:'row',
        justifyContent:'space-around',
    },
    mainContainer: {
        position: 'relative',
        maxWidth: '480px',
        minHeight: '600px',
        display: 'flex',
        flexDirection: 'column',
        border: '1px solid grey',
        borderRadius: '20px',
        borderColor: '#ffff',
        backgroundColor: '#ffff',
        transition: 'transform 0.6s',
        boxShadow: "0 15px 15px rgba(0, 0, 0, 0.2)",
        "&:hover": {
            transform: 'scale(1.1)'
        },
    },
    imageContainer:{
        overflow:'hidden',
        margin:'5px',
        border: '1px solid #ffff',
        borderRadius: '15px',
        height:'auto'
    },
    GridContainer:{
        padding:'20px',
        display:'flex', 
        flexDirection:'column',
        justifyContent:'space-between'
    },
    fieldContainer:{
        display:'inline', 
        flexDirection:'row',
        paddingTop:'5px',

    },
    label: {
        fontSize: "0.875rem",
        position: "absolute",
        left: "-12px",
        top: "20px",
        height:'25px',
        color: "#fff",
        textAlign: "left",
        borderTop:'15px solid red',
        borderBottom:'15px solid red',
        borderRight:'15px solid transparent',
        borderRadius: "0px 0px 0px 5px",
        backgroundColor: 'transparent',
        display:'flex',
        flexDirection:'column', 
        justifyContent:'center',
        alignItems:'start',
        padding:'0px 10px 0px 10px',
        boxShadow:'5px',
        fontWeight:'bold' 
    }
}

const typeData = [
    //{
    //    imgPath: 'images/cdsl.png',
    //    altImg: "CVL",
    //    type: 'withCVLKRA',
    //    isRecomended: true,
    //    titlePAN:'1. PAN',
    //    descPAN:'',
    //    titleAdd:'2. Address Proof',
    //    descAdd:'(Aadhaar Card)',
    //    titleBank:'3. Bank Proof',
    //    descBank:'Bank Statement (In case online IMPS Verification fails)',
    //    titleSign:'4. Signature Proof',
    //    descSign:'(Photo of your signature on plain white paper)',
    //    titleIncome:'5. Income Proof',
    //     descIncome:'(In case you wish to trade in Derivatives)'
    //},
    {
        imgPath: 'images/digilocker.png',
        altImg: "Digilocker",
        type: 'withDigiLocker',
        isRecomended: false,
        titlePAN:'1. PAN',
        descPAN:'(If not available on digilocker)',
        titleAdd:'2. Address Proof',
        descAdd:'(Aadhaar Card)',
        titleBank:'3. Bank Proof',
        descBank:'Bank Statement (In case online IMPS Verification fails)',
        titleSign:'4. Signature Proof',
        descSign:'(Photo of your signature on plain white paper)',
        titleIncome:'5. Income Proof',
        descIncome:'(In case you wish to trade in Derivatives)'
    },
    {
        imgPath: 'images/withoutdigilocker.png',
        altImg: "Manual",
        type: 'withoutDigiLocker',
        isRecomended: false,
        titlePAN:'1. PAN',
        descPAN:'',
        titleAdd:'2. Address Proof',
        descAdd:'(Aadhaar Card)',
        titleBank:'3. Bank Proof',
        descBank:'Bank Statement (In case online IMPS Verification fails)',
        titleSign:'4. Signature Proof',
        descSign:'(Photo of your signature on plain white paper)',
        titleIncome:'5. Income Proof',
        descIncome:'(In case you wish to trade in Derivatives)'
    }
]

function ThirdParty(props) {
    const theme = useTheme();
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const store = useSelector(state => state.storeState.stage)
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'))
    const [logger, setLogger] = useState()
    const [snackBarOpen, setSnackBarOpen] = useState(false);
    const [responseStatus, setResponseStatus] = useState({})
    const [openConfirmationPopup, setOpenConfirmationPopup] = useState(false)
    const [openWithoutDigiLockerConfirmationPopup, setOpenWithoutDigiLockerConfirmationPopup] = useState(false)
    const localeText = useContext(Il8nContext)
    const [openAadhaarSeededPopup, setOpenAadhaarSeededPopup] = useState(false)
    const [aadhaarSeededMessage, setAadhaarSeededMessage] = useState()
    const [recomendedPlan, setRecomendedPlan] = useState("withCVLKRA")
    const [digiLockerSucceed, setDigiLockerSucceed] = useState(false)
    const [successData, setSuccessData] = useState(null);
    const [loading, setLoading] = useState(false)
    const stepper = useSelector(state => state.storeState.stepper)

    useEffect(() => {
        getStageDetails();
        if (window?.location?.search) {
            const params = new URLSearchParams(window.location.search)
            if (!(params.get('status') === 'success' || params.get('status') === 'error')) {
                getStageDetails();
            }
            else if (params.get('status') === 'success') {
                axios.post(process.env.REACT_APP_API_URL + config.getDigiLockerData, {}).then(resp => {
                    if (resp?.data?.success?.length > 0) {
                        const data = resp.data.success[0];
                        if (data?.isDigilocker) {
                            setSuccessData(data);
                            setDigiLockerSucceed(true);
                        } else {
                            handleSuccessData(data);
                        }
                    } else if(resp?.data?.error) {
                        throw new Error(resp?.data?.error)
                    }
                }).catch((error) => {
                    setResponseStatus({ "message": error.message, "type": "error" })
                    setSnackBarOpen(true)
                })
            } else {
                setResponseStatus({ "message": "Error occured, Please try with other options", "type": "error" })
                setSnackBarOpen(true)
            }
        }
    }, [])

    const handleSuccessData = (successData) => {
        if (successData?.accountOpeningType == "DIGI" || successData?.accountOpeningType == "SUBKUA" || successData?.accountOpeningType == "" || !(successData?.accountOpeningType)) {
            localStorage.setItem("tempData", JSON.stringify(successData))
            if (successData.isDigilocker) {
                dispatch(addStageData({ ...store, digilockerData: successData, isDigilockerDataFound: true }))
            } else {
                dispatch(addStageData({ ...store, digilockerData: successData, isDigilockerDataFound: false }))
            }
            if (successData?.aadhaarSeededMessage) {
                setAadhaarSeededMessage(successData?.aadhaarSeededMessage)
                toggleAadhaarVerifiedPopup()
            }
            else {
                navigate("/ThirdPartyKYCVerification")
            }
            navigate("/ThirdPartyKYCVerification")
        }
    }

    const handleDialogClose = () => {
        setDigiLockerSucceed(false);
        if (successData) {
            handleSuccessData(successData);
        }
    };
    const getStageDetails = (isSignUpCall) => {
        setLoading(true)
        isSignUpCall && dispatch(addStageData({ ...store, "appStages": appStages }))
        localStorage.clear()
        localStorage.setItem("appStages", JSON.stringify(appStages))
        axios.get(process.env.REACT_APP_API_URL + config.stageDetails)
            .then(resp => {
                setLoading(false)
                if (resp.data.success) {
                    setCookieNew("referalCode", resp.data.success.subBrokerCode || "")
                    if (resp.data.success.stageDetilasList && resp.data.success.stageDetilasList.length > 0) {
                        localStorage.setItem("appStages", JSON.stringify(resp.data.success.stageDetilasList))
                        function modifySteps (mf) {
                            if (mf) {
                                Steps[1].steps.push({stageCode: "NOMM"})
                            }
                            return Steps
                        }

                        const getStep = (response, code) => {
                            const step = response.filter((st) => {return st.stageCode === code})
                            return step[0].status
                        }

                        modifySteps(resp.data.success.isMF).forEach((step) => {
                            step.status = getStep(resp.data.success.stageDetilasList, step.stageCode)
                            if (step.steps && step.steps.length > 0) {
                                step.steps.forEach((ns) => {
                                    ns.status = getStep(resp.data.success.stageDetilasList, ns.stageCode)
                                    if (resp.data.success.isMF && (ns.stageCode == "PAY" || ns.stageCode == "BROK")) {
                                        ns.status = 1
                                    } else if (ns.stageCode == "PAY" && ns.status == 1) {

                                    }
                                })
                            }
                        })

                        for (let i = 0; i < Steps.length; i++) {
                            let arr = ["/ThirdParty", "/Profile", "/BankDetails", "/PlanDetails", "/Upload", "/Review", "/Esign", "/Courier", "/Scrutiny", "/Objection"]
                            if (!Steps[i].steps && Steps[i].status === 0) {
                                if (resp.data.success.isMF && i > 2) {
                                    navigate(arr[i - 1]);
                                    return
                                }
                                navigate(arr[i]);
                                return
                            }
                            if (Steps[i].steps && Steps[i].steps.length > 0) {
                                for (let j = 0; j < Steps[i].steps.length; j++) {
                                    if (Steps[i].steps[j].status === 0) {
                                        let nestedStepNavs = {
                                            "PERSO": "/Profile",
                                            "ADD": "/AddressDetails",
                                            "BASIC": "/AddressDetails",
                                            "BROK": "/PlanDetails",
                                            "PAY": "/Payment"
                                        }
                                        if (resp.data.success.isMF && i > 2) {
                                            navigate(nestedStepNavs[Steps[i].steps[j].stageCode]);
                                            return
                                        }

                                        navigate(nestedStepNavs[Steps[i].steps[j].stageCode]);
                                        return
                                    }
                                }
                            }
                        }

                    }
                } else {
                    throw new Error()
                }
            }).catch((err) => {
                setLoading(false)
            })
    }

    const toggleAadhaarVerifiedPopup = () => {
        setOpenAadhaarSeededPopup(!openAadhaarSeededPopup)
    }

    function handleSnackBarClose() {
        setSnackBarOpen(false)
        setResponseStatus()
    }

    const handleProceedClick = (value) => {
        setLogger(value)
        value == "withoutDigiLocker" ? setOpenWithoutDigiLockerConfirmationPopup(!openWithoutDigiLockerConfirmationPopup) : value == "withDigiLocker" ? setOpenConfirmationPopup(!openConfirmationPopup) : value == "withCVLKRA" && setOpenConfirmationPopup(!openConfirmationPopup)
    }

    const handleDigiLockerSelection = (e) => {
        setLogger(e.currentTarget.value)
    }

    const toggleWithoutDigilockerPopup = (e) => {
        setOpenWithoutDigiLockerConfirmationPopup(!openWithoutDigiLockerConfirmationPopup)
    }

    const continueWithoutDigilocker = () => {
        toggleWithoutDigilockerPopup()
        // window.open(`${window.location.origin}${"/KYCVerification"}`, "_self")
        navigate("/KYCVerification")
    }

    const toggleWithDigilockerPopup = () => {
        setOpenConfirmationPopup(!openConfirmationPopup)
    }

    const continueWithThirdPartyPage = (type) => {
        toggleWithDigilockerPopup()
        let URL= type === "withCVLKRA" ? process.env.REACT_APP_CVL_URL : process.env.REACT_APP_DIGILOCKER_URL
        window.open(URL, '_self')
    }
  
    return (
        <>
            <PageLayout css={{ overflowY: "scroll" }} hideSidebarGrid={isSmallScreen ? true : false} calculateHeight={isSmallScreen ? true : false}>
                <ElevatedGrid >
                    <Grid container item alignItems={"start"} >
                        <Grid item>
                        <Typography display="inline" fontSize={"24px"} fontWeight={"bold"} color="#525D72">
                            {localeText?.ChooseProcessForAcOpenening}
                        </Typography>
                        </Grid>
                        <Grid container style={classes.topContainer} /*spacing={2}*/>
                        {
                            typeData?.map((val, ind)=>(
                            <Grid container xl={3.75} lg={3.75} md={6} sm={12} xs={12} 
                            onMouseOver={()=>setRecomendedPlan()}
                            onMouseOut={()=>setRecomendedPlan()}
                            sx={{
                                position: 'relative',
                                maxWidth:'480px',
                                minHeight: '550px',
                                display: 'flex',
                                flexDirection:'column',
                                border: '1px solid grey',
                                borderRadius: '20px',
                                borderColor:'#f7f7f7',
                                backgroundColor:'#ffff',
                                transition: 'transform 0.6s',
                                marginY:isSmallScreen ? '35px' : '',
                                boxShadow: "0 15px 15px rgba(0, 0, 0, 0.2)",
                                "&:hover": {
                                    transform: 'scale(1.1)',
                                 },
                                 transform: recomendedPlan == "withCVLKRA" && val?.isRecomended ? 'scale(1.1)' : ''
                            }}
                             >
                            <Grid style={classes.imageContainer}>
                                {
                                    val?.isRecomended &&
                                    <Grid style={classes.label} sx={{
                                        content:'""',
                                        fontSize: "0.875rem",
                                        position: "absolute",
                                        left: "-12px",
                                        top: "20px",
                                        height:'25px',
                                        color: "#fff",
                                        textAlign: "left",
                                        borderTop:'15px solid red',
                                        borderBottom:'15px solid red',
                                        borderRight:'15px solid transparent',
                                        borderRadius: "0px 0px 0px 5px",
                                        backgroundColor: 'transparent',
                                        display:'flex',
                                        flexDirection:'column', 
                                        justifyContent:'center',
                                        alignItems:'start',
                                        padding:'0px 10px 0px 10px',
                                        boxShadow:'5px',
                                        fontWeight:'bold',
                                        '&::before': {
                                            position: "absolute",
                                            content: '""',
                                            left:0,
                                            bottom:'-24px',
                                            width:0,
                                            height:0,
                                            borderLeft:'12px solid transparent',
                                            borderRight:'0 solid transparent',
                                            borderTop:'12px solid #8F0505'
                                        } 
                                    }}>Recomended</Grid>
                                }
                            <img src={val?.imgPath} alt={val?.altImg} style={{ maxWidth: "100%", minHeight: "100%"}} />
                            </Grid>
                            <Grid style={classes.GridContainer}>
                                <Grid sx={{paddingY:isSmallScreen ? '5px' : '10px'}}>
                                <Typography variant='p' sx={{color:'#24b7cc', fontWeight:'bold'}}>Keep the below documents handy before proceeding</Typography>
                                        </Grid>
                                        <Grid style={classes.fieldContainer}>
                                            <Typography variant='p' paddingRight={"5px"} sx={{ fontWeight: 'bold', fontSize: '14px' }}>{val?.titlePAN}</Typography>
                                            <Typography variant='p' sx={{ fontSize: '12px', display: 'inline-block' }}>{val?.descPAN}</Typography>
                                        </Grid>
                                        <Grid style={classes.fieldContainer}>
                                            <Typography variant='p' paddingRight={"5px"} sx={{ fontWeight: 'bold', fontSize: '14px' }}>{val?.titleAdd}</Typography>
                                            <Typography variant='p' sx={{ fontSize: '12px', display: 'inline-block' }}>{val?.descAdd}</Typography>
                                        </Grid>
                                        <Grid style={classes.fieldContainer}>
                                            <Typography variant='p' paddingRight={"5px"} sx={{ fontWeight: 'bold', fontSize: '14px' }}>{val?.titleBank}</Typography>
                                            <Typography variant='p' sx={{ fontSize: '12px', display: 'inline-block' }}>{val?.descBank}</Typography>
                                        </Grid>
                                        <Grid style={classes.fieldContainer}>
                                            <Typography variant='p' paddingRight={"5px"} sx={{ fontWeight: 'bold', fontSize: '14px' }}>{val?.titleSign}</Typography>
                                            <Typography variant='p' sx={{ fontSize: '12px', display: 'inline-block' }}>{val?.descSign}</Typography>
                                        </Grid>
                                        <Grid style={classes.fieldContainer}>
                                            <Typography variant='p' paddingRight={"5px"} sx={{ fontWeight: 'bold', fontSize: '14px' }}>{val?.titleIncome}</Typography>
                                            <Typography variant='p' sx={{ fontSize: '12px', display: 'inline-block' }}>{val?.descIncome}</Typography>
                                        </Grid>
                                    </Grid>
                                    <Button sx={{
                                        position: 'absolute',
                                        bottom: '-20px',
                                        left: !isSmallScreen ? '48px' : '28px',
                                        width: '80%',
                                        height: '50px',
                                        fontSize: '20px'
                                    }}
                                        variant='contained' onClick={()=>handleProceedClick(val?.type)}>Proceed
                                    </Button>
                        </Grid>
                            ))
                        }
                        </Grid>
                        <Grid>
                            <Typography display="inline" fontSize={"18px"} fontWeight={"bold"} color="black">
                                {localeText?.digilockerImportant} :
                            </Typography>
                            <List sx={{ listStyle: "decimal", marginX: '20px', padding: 0, marginY: 0 }}>
                                <ListItem sx={{ display: 'list-item', fontSize: "16px" }}>
                                    {localeText?.digilockerImportant1}
                                </ListItem>
                                <ListItem sx={{ display: 'list-item', fontSize: "16px" }}>
                                    {localeText?.digilockerImportant2}
                                </ListItem>
                                <ListItem sx={{ display: 'list-item', fontSize: "16px" }}>
                                    {localeText?.digilockerImportant3}
                                </ListItem>
                                <ListItem sx={{ display: 'list-item', fontSize: "16px" }}>
                                    {localeText?.digilockerImportant4}
                                </ListItem>
                            </List>
                        </Grid>

                        
                    </Grid>
                </ElevatedGrid>

            </PageLayout>

            {
                <Popup
                    open={digiLockerSucceed}
                    maxWidth={"sm"}
                >
                    <DialogContent css={{ textAlign: "center", margin: "0px 30px" }}>
                        <Typography>
                            {localeText?.DigiLockerKYCVerificationSuccess}
                        </Typography>
                        <Button variant="contained" color="primary" css={{ margin: "25px" }} onClick={handleDialogClose} >
                            {localeText?.digiLockerOk}
                        </Button>
                    </DialogContent>
                    <DialogActions>
                    </DialogActions>
                </Popup>
            }
            <Popup
                open={openConfirmationPopup}
                maxWidth={"sm"}
            >
                <PopupTitle onClose={toggleWithDigilockerPopup} />
                <DialogContent css={{ textAlign: "center", margin: "0px 30px" }}>
                    <img src="images/icon_digilocker_popup.svg" alt="icon_digilocker_popup" css={{ marginBottom: "20px" }} />
                    <Typography>
                        {localeText?.digiLockersupervision}
                    </Typography>
                    <Button variant="contained" color="primary" css={{ margin: "25px" }} onClick={()=>{continueWithThirdPartyPage(logger)}} >
                        {localeText?.digiLockerAgree}
                    </Button>
                </DialogContent>
                <DialogActions>
                </DialogActions>
            </Popup>

            <Popup
                open={openWithoutDigiLockerConfirmationPopup}
                maxWidth={"sm"}
            >
                <PopupTitle onClose={toggleWithoutDigilockerPopup} />
                <DialogContent css={{ textAlign: "center", margin: "0px 30px" }}>
                    <img src="images/icon_digilocker_popup.svg" alt="icon_digilocker_popup" css={{ marginBottom: "20px" }} />
                    <Typography>
                        {localeText?.digiLockerproofs}
                    </Typography>
                    <Button variant="contained" color="primary" css={{ margin: "25px" }} onClick={continueWithoutDigilocker}>
                        {localeText?.digiLockerAgree}
                    </Button>
                </DialogContent>
                <DialogActions>
                </DialogActions>
            </Popup>

            <Popup
                open={openAadhaarSeededPopup}
                maxWidth={"sm"}
            >
                <PopupTitle dontShowCloseIcon />
                <DialogContent css={{ textAlign: "center", margin: "0px 60px" }}>
                    <Grid container direction={"column"} alignItems={"center"} justifyContent="center">
                        <Grid item>
                            <Typography variant="h6" css={{ fontWeight: "bold" }}>
                                {aadhaarSeededMessage}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} css={{ padding: "20px 0" }}>
                            <Button variant="contained" color="secondary" css={{ textTransform: "none" }} onClick={() => { toggleAadhaarVerifiedPopup(); navigate("/ThirdPartyKYCVerification") }}>
                                {localeText?.bankDetailsNextBtn}
                            </Button>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Popup>

            <Popup
                open={false}
                maxWidth={"sm"}
            >
                <PopupTitle />
                <DialogContent css={{ textAlign: "center", margin: "0px 60px" }}>
                    <Grid direction={"column"} container alignItems={"center"} justifyContent="center">
                        <Grid item>
                            <img src="images/icon_Bank-IMPS-Successful.svg" alt="success" />
                        </Grid>
                        <Grid item>
                            <Typography variant="h6">
                                {localeText?.digiLockerSuccess}
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography variant="body1">
                                {localeText?.digiLockerDocument}
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Button variant="outlined" color="primary" css={{ margin: "25px" }}>
                                {localeText?.digiLockerOk}
                            </Button>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                </DialogActions>
            </Popup>
            {
                responseStatus && responseStatus.message && <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    open={snackBarOpen}
                    autoHideDuration={5000}
                    onClose={handleSnackBarClose}
                >
                    <MySnackbarContentWrapper
                        onClose={handleSnackBarClose}
                        variant={responseStatus.type}
                        message={responseStatus.message}
                    />
                </Snackbar>
            }
        </>
    );
}

export default ThirdParty;